import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchTrailerRGD } from 'queries/trailer/trailer'
import { trailerRGDFetchProps } from 'types/api'
import { IResponseTrailerRGD } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useTrailerRGD({
    env,
    accessToken,
    location,
}: trailerRGDFetchProps): IResponseTrailerRGD {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()

    if (location === 'Company Target' || location === 'Company') {
        location = 'TARGET'
    }

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.TRAILER_RGD, location],
        () =>
            fetchTrailerRGD({
                env,
                accessToken,
                filters: {
                    location_id: location,
                },
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
